// extracted by mini-css-extract-plugin
export var content = "_vb-1";
export var wrapper = "_vb-0";